export default [
  {
    title: '기초등록',
    icon: 'DatabaseIcon',
    children: [
      {
        title: '조건검색',
        route: 'kiwoom-condition-search',
      },
      {
        title: '테마',
        route: 'kiwoom-theme',
      },
      {
        title: '네이버테마',
        route: 'kiwoom-naver-theme',
      },
      {
        title: '종목',
        route: 'kiwoom-stock-item',
      },
      {
        title: '증권회사',
        route: 'kiwoom-securities-company',
      },
    ],
  },
]
